import React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { limiter } from '@ott/superagent';

import LayoutPage from 'src/components/pages/LayoutPage';

const mapStateToProps = (state) => {
  const {
    landings: { config },
  } = state;

  return {
    config,
  };
};

class App extends React.PureComponent {
  renderRoute = () => {
    return <LayoutPage />;
  };

  getRouteNode() {
    const { config } = this.props;
    const defaultRoute = <Route path="/:lang" render={this.renderRoute} />;

    if (config.customRoutes) {
      const routes = [
        defaultRoute,
        ...config.customRoutes.map(({ url, lang }) => {
          return <Route path={url} render={this.renderRoute} />;
        }),
      ];

      return <Switch>{routes}</Switch>;
    }

    return defaultRoute;
  }

  render() {
    const routeNode = this.getRouteNode();

    if (__SERVER__) {
      return routeNode;
    }

    return (
      <>
        <BrowserRouter>{routeNode}</BrowserRouter>
        <limiter.Captcha />
      </>
    );
  }
}

export default connect(mapStateToProps)(App);
